/** @format */

import React from "react";
import { timeout } from "../utils/utilitys";
import PhoneNumber from "../dao/PhoneNumber";
// import { getContactActive } from "../../helpers/fetch_helper";
const useGetPhoneNumberByWABA = (waba) => {
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const handleGet = async () => {
      await setIsLoading(true);
      await timeout(2000);
      let response = await PhoneNumber.getAll(waba);
      const arr = Array.from(response, function (item) {
        return {
          value: item.display_phone_number.replace(/[^\d]/g, ""),
          label: item.display_phone_number.replace(/[^\d]/g, ""),
        };
      });
      setData(arr);
      await setIsLoading(false);
    };
    let fetch = true;
    if (fetch) {
      try {
        handleGet();
      } catch (err) {
        setData(null);
      }
    }
    return () => {
      fetch = false;
    };
  }, [waba]);

  return { data, isLoading };
};

export default useGetPhoneNumberByWABA;
